(function() {
    var __webpack_require__ = {};
    !function() {
        __webpack_require__.r = function(exports) {
            if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
                Object.defineProperty(exports, Symbol.toStringTag, {
                    value: "Module"
                });
            }
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
        };
    }();
    var __webpack_exports__ = {};
    !function() {
        if (!window.customImageBannerSplitScriptLoaded) {
            window.customImageBannerSplitScriptLoaded = true;
            function initCustomImageBannerSwiper() {
                const swiperContainers = document.querySelectorAll(".cibs-swiper");
                swiperContainers.forEach((container => {
                    if (container.classList.contains("swiper-initialized")) return;
                    const paginationEl = container.querySelector(".swiper-pagination");
                    const delay = parseInt(container.dataset.autoplayDelay) || 4e3;
                    new Swiper(container, {
                        loop: true,
                        autoplay: {
                            delay: delay,
                            disableOnInteraction: false
                        },
                        pagination: {
                            el: paginationEl,
                            clickable: true
                        }
                    });
                }));
            }
            document.addEventListener("DOMContentLoaded", initCustomImageBannerSwiper);
            document.addEventListener("shopify:section:load", initCustomImageBannerSwiper);
        }
    }();
    !function() {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
    }();
})();